let observer: IntersectionObserver | null = null

function getObserver(): IntersectionObserver {
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = entry.target as HTMLImageElement
            if (img.dataset.src) {
              img.src = img.dataset.src
              img.removeAttribute('data-src')

              img.onload = () => {
                img.classList.add('loaded')
                img.parentElement?.classList.remove('skeleton-shimmer')
              }
            }
            observer?.unobserve(img)
          }
        })
      },
      { rootMargin: '200px 0px' }
    )
  }
  return observer
}

export function initLazyImages(container: HTMLElement | Document = document): void {
  const lazyImages = container.querySelectorAll('img.lazy-image')
  const obs = getObserver()
  lazyImages.forEach((img) => obs.observe(img))
}
